import { createSlice } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

export default function createStore({ storeName, initialState, reducers }) {
  const { reducer, actions } = createSlice({
    name: storeName,
    initialState,
    reducers
  });

  return {
    reducer,
    actions,
    useStore: () => {
      const dispatch = useDispatch();
      const store = useSelector((state) => state[storeName]);

      return [
        store,
        Object.keys(actions).reduce((acc, action) => {
          acc[action.toString()] = (...args) => actions[action] && dispatch(actions[action](...args));
          return acc;
        }, {})
      ];
    }
  };
}
